import React from 'react';
import CountUp from 'react-countup';

// images
import icon1 from '../../images/funfact/1.svg';
import icon2 from '../../images/funfact/2.svg';
import icon3 from '../../images/funfact/3.svg';
import icon4 from '../../images/funfact/4.svg';


import ImageBg from '../../images/funfact/funfact2.png';



const FunFact = (props) => {

    return (

        <section className="funfact-section">
            <div className="top-image">
                <img src={ImageBg} alt="" />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <img src={icon1} alt="" />
                            </div>
                            <h2><CountUp end={65} enableScrollSpy /><span className="ico"> L</span>
                            </h2>
                            <h3>Spazio interno per il massimo comfort.</h3>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <img src={icon2} alt="" />
                            </div>
                            <h2><CountUp end={15} enableScrollSpy /><span className="ico"> giorni</span>
                            </h2>
                            <h3>Autonomia media di pulizia per un singolo gatto.</h3>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <img src={icon3} alt="" />
                            </div>
                            <h2><CountUp end={14} decimals={1} enableScrollSpy /><span className="ico"> cm</span>
                            </h2>
                            <h3>Altezza d'ingresso facilitata (ideale per gattini e senior).</h3>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <img src={icon4} alt="" />
                            </div>
                            <h2><CountUp end={24} enableScrollSpy /><span className="ico"> mesi</span>
                            </h2>
                            <h3>Garanzia ufficiale e supporto dedicato.</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )

}

export default FunFact;




